import styled from "@emotion/styled";
import { H2, Link, Text, Stack } from "atoms";
import { useArtistApplication } from "features/admin/api/useArtistApplications";
import { ArtistApplicationWorkflowStatus } from "features/admin/components/ArtistApplicationWorkflowStatus";
import { Artist } from "../types";

function ArtistAdminSection({ entity }: { entity: Artist }) {
  const rawApplicationId = entity.applicationId;
  const parsedApplicationId = rawApplicationId?.includes("~")
    ? rawApplicationId.split("~")?.[1]
    : rawApplicationId;
  const { data } = useArtistApplication(parsedApplicationId);
  const application = data?.application;

  return (
    <Stack
      gap="sm"
      style={{
        backgroundColor: "#f2f2f2",
        padding: "1em",
        borderRadius: 4,
        marginBottom: "1rem",
        marginTop: "2rem",
      }}
    >
      <Stack gap="0">
        <H2 size="md" style={{ margin: 0 }}>
          Profile Info
        </H2>
        <Text size="xxxs" as="small">
          <em>Visible to admins only</em>
        </Text>
      </Stack>

      <CapitalizedText size="xxs">
        {entity.status?.toLowerCase()}{" "}
        {entity.adminUsers?.length ? "Claimed" : "Not Claimed"}
      </CapitalizedText>

      {!!entity.adminUsers?.length && (
        <Stack gap="0">
          <Text size="xxs">Admin users</Text>
          {entity.adminUsers.map((id) => (
            <div key={id}>
              <Link to={`/admin/users/${id}`}>
                {id.substring(0, 6)}...{id.slice(-6)}
              </Link>
            </div>
          ))}
        </Stack>
      )}

      {entity.applicationId && (
        <>
          <Text size="xxs">
            <Link
              to={`/admin/applications/APPLICATION~${entity.applicationId}`}
            >
              View Artist Application
            </Link>
          </Text>
          {application && (
            <ArtistApplicationWorkflowStatus app={data?.application} />
          )}
        </>
      )}
    </Stack>
  );
}

const CapitalizedText = styled(Text)({
  textTransform: "capitalize",
});

export { ArtistAdminSection };
